import { render, staticRenderFns } from "./Specializations.vue?vue&type=template&id=073d62ef&scoped=true"
import script from "./Specializations.vue?vue&type=script&lang=js"
export * from "./Specializations.vue?vue&type=script&lang=js"
import style0 from "./Specializations.vue?vue&type=style&index=0&id=073d62ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073d62ef",
  null
  
)

export default component.exports